module.exports = __webpack_public_path__ + "static/media/headerLogo_ozo.bd652a44.png";